export default __webpack_public_path__ + "static/media/gaming-joy.bf4e525c.jpeg";